import React from 'react'
import './ScrimbaTransition.css'

const ScrimbaTransition = () => {
  return (
    <div className='scrimbaTransition'>
      <div className="box"></div>
    </div>
  )
}

export default ScrimbaTransition